// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"a8dbf415","453":"cd856d97","920":"43996b59"}[chunkId] + ".chunk.js";
};